import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MOBILE_APP_HOME_PATH } from '../../utils/mobileApp';
import { getMobileChromeTheme } from '../../utils/mobileTheme';

function titleForPath(pathname: string): string {
  if (pathname.startsWith('/add-product')) return 'Thêm phòng';
  if (pathname.startsWith('/edit-product')) return 'Sửa phòng';
  if (pathname.startsWith('/contracts')) return 'Hợp đồng';
  if (pathname.startsWith('/upgrade')) return 'Nâng cấp gói';
  if (pathname.startsWith('/auth/kyc')) return 'Xác minh KYC';
  return 'Quản lý';
}

const MobileInAppChrome: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isLight = getMobileChromeTheme() === 'light';

  return (
    <div className={`kcn-native-shell relative flex h-[100dvh] max-h-[100dvh] flex-col overflow-hidden ${isLight ? 'kcn-theme-light' : ''}`}>
      <header className="kcn-native-header shrink-0 px-3 pb-3 pt-[calc(0.75rem+env(safe-area-inset-top))]">
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => navigate(MOBILE_APP_HOME_PATH, { replace: true })}
            className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#C4A35A] text-white"
            aria-label="Về quản lý"
          >
            <i className="fas fa-arrow-left text-sm" />
          </button>
          <p className={`truncate text-sm font-bold ${isLight ? 'text-black' : 'text-white'}`}>
            {titleForPath(pathname)}
          </p>
        </div>
      </header>
      <div className="min-h-0 flex-1 overflow-y-auto bg-white">
        {children}
      </div>
    </div>
  );
};

export default MobileInAppChrome;
